import { Dot } from 'lucide-react';

export function TypingIndicator() {
  return (
    <div className="justify-left flex space-x-1">
      <div className="rounded-lg bg-gray-100 dark:bg-gray-800 p-3">
        <div className="flex -space-x-2.5">
          <Dot className="h-5 w-5 animate-typing-dot-bounce text-gray-500 dark:text-gray-400" />
          <Dot className="h-5 w-5 animate-typing-dot-bounce [animation-delay:90ms] text-gray-500 dark:text-gray-400" />
          <Dot className="h-5 w-5 animate-typing-dot-bounce [animation-delay:180ms] text-gray-500 dark:text-gray-400" />
        </div>
      </div>
    </div>
  );
}
